import { AddToCart } from '@frontend/storefront/components/cart/add-to-cart';
import { display } from '@frontend/storefront/components/home/styles';
import Price from '@frontend/storefront/components/price';
import { VariantSelector } from '@frontend/storefront/components/product/variant-selector';
import Prose from '@frontend/storefront/components/prose';
import { Product } from '@frontend/storefront/lib/shopify/types';

export function ProductDescription({ product }: { product: Product }) {
  return (
    <>
      <div className="mb-6 flex flex-col gap-4 border-b border-np-ink/20 pb-6">
        <h1 className={display}>{product.title}</h1>
        <div className="font-hand text-2xl leading-none tracking-[-0.02em] text-np-pink">
          <Price
            amount={product.priceRange.maxVariantPrice.amount}
            currencyCode={product.priceRange.maxVariantPrice.currencyCode}
          />
        </div>
      </div>
      <VariantSelector options={product.options} variants={product.variants} />
      {product.descriptionHtml ? (
        <Prose className="mb-8" html={product.descriptionHtml} />
      ) : null}
      <AddToCart product={product} />
    </>
  );
}
